<template lang="pug">
  .b-file-dropzone(
    :class="{ dragHover: hoverCounter > 0 }"
    @dragover.prevent
    @dragenter.prevent="hoverCounter++"
    @dragleave.prevent="hoverCounter--"
    @drop.prevent="onDrop"
    )
    Icon._icon(name="upload-dropzone")
    ._text
      ._header0 Перенесите файлы сюда
      ._header1 или нажмите кнопку
      Btn(label)._btn Загрузить файлы
        input._input(type="file" hidden multiple :data-testid="inputTestId" @change="$emit('drop', $event.target.files)")
</template>

<script>
export default {
  name: 'FileDropzone',
  props: {
    // (Claude) тестовая метка на самом поле выбора файла: сценарии передают файл через
    // setInputFiles, поэтому метка нужна на input, а не на зоне перетаскивания (ТЗ 12.8)
    inputTestId: String,
  },
  data() {
    return {
      hoverCounter: 0,
      dragHover: false,
    };
  },
  methods: {
    onDrop(e) {
      this.hoverCounter = 0;
      this.$emit('drop', e.dataTransfer.files);
    },
  },
};
</script>

<style scoped lang="scss">
  .file-dropzone {
    border: 1px dashed var(--color-violent-gray);
    background: #F8F9FC;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 33px 0;

    &__input {
      opacity: 0;
      visibility: hidden;
      position: absolute;
    }

    &.dragHover {
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
      border-color: var(--color-turquoise)
    }

    &__text {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 7px;
    }

    &__header0 {
      font-size: 18px;
    }

    &__header1 {
      font-size: 12px;
    }

    &__btn {
      margin-top: 17px;
    }

    @media (max-width: 768px) {
      &__icon,
      &__header0,
      &__header1 {
        display: none;
      }

      &__btn {
        margin-top: 0;
      }
    }
  }
</style>
